"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var BUILDING_EMPATHY = "BUILDING_EMPATHY";
var questions = [{
  prompt: "To start with, can you write the visible behaviour that they do that’s annoying you?",
  type: "multiWithOther",
  options: ["Interrupting", "Complaining", "Being argumentative", "Being greedy or selfish", "Other"],
  meta: {
    summaryTitle: "The visible behaviour that they do that’s annoying you"
  },
  batteryId: BUILDING_EMPATHY
}, {
  prompt: "Next, what are the reasons why the behaviour is annoying for you personally based on your upbringing and how you were taught when you were young?",
  type: "multiWithOther",
  options: ["The behaviour was seen as bad in my family", "My parent(s) did the behaviour and I hated it", "I had some bad experiences with this type of behaviour when young", "Other"],
  meta: {
    summaryTitle: "reasons why the behaviour is annoying for you personally based on your upbringing and how you were taught when you were young"
  },
  batteryId: BUILDING_EMPATHY
}, {
  prompt: "How do you visibly behave towards them when they do the behaviour?",
  type: "multiWithOther",
  options: ["Shut down, withdraw, go quiet", "Passive aggressive", "Laugh and make a joke of it", "Other"],
  meta: {
    summaryTitle: "How do you visibly behave towards them when they do the behaviour?"
  },
  batteryId: BUILDING_EMPATHY
}, {
  prompt: "When you act that way towards them, can you imagine any reasons from their upbring why they would find your behaviour difficult?",
  type: "multiWithOther",
  options: ["My behaviour was seen as bad in their family", "Their parents did what I’m doing towards them and he/she hated it", "They had bad experiences with the behaviour I do when they were young", "Other"],
  batteryId: BUILDING_EMPATHY
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;